import { MyLink } from '~/components/ui/MyLink'

export const AgreementComp = () => {
  return (
    <p className="text-xs text-neutral-500 mt-4 pb-8">
      使用无界AI创作服务表示您已同意
      <MyLink href="/us/ai-agreement" className="primary-color" exist={true}>
        《AI创作服务协议》
      </MyLink>
      <MyLink href="/us/ai-ad-agreement" className="primary-color" exist={true}>
        《二次元模型AI创作服务协议》
      </MyLink>
    </p>
  )
}
